/**
 * 브라우저 핑거프린트 생성 (결정적 - 항상 같은 값)
 * 같은 브라우저/기기에서는 항상 동일한 값 계산
 */
export const generateFingerprint = async (): Promise<string> => {
    const components: string[] = [];

    // 1. Canvas Fingerprint
    try {
        const canvas = document.createElement('canvas');
        canvas.width = 200;
        canvas.height = 50;
        const ctx = canvas.getContext('2d');
        if (ctx) {
            ctx.textBaseline = 'top';
            ctx.font = '14px Arial';
            ctx.fillStyle = '#f60';
            ctx.fillRect(125, 1, 62, 20);
            ctx.fillStyle = '#069';
            ctx.fillText('Sokcho Girls HS', 2, 15);
            ctx.fillStyle = 'rgba(102, 204, 0, 0.7)';
            ctx.fillText('Device Fingerprint', 4, 35);
        }
        components.push(canvas.toDataURL());
    } catch (e) {
        components.push('canvas-error');
    }

    // 2. WebGL Fingerprint
    try {
        const canvas = document.createElement('canvas');
        const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
        if (gl && gl instanceof WebGLRenderingContext) {
            const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
            if (debugInfo) {
                const vendor = gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL);
                const renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
                components.push(`${vendor}|${renderer}`);
            }
        }
    } catch (e) {
        components.push('webgl-error');
    }

    // 3. 시스템 정보
    components.push(navigator.userAgent);
    components.push(navigator.language);
    components.push(navigator.platform);
    components.push(String(navigator.hardwareConcurrency || 0));
    components.push(String(navigator.maxTouchPoints || 0));

    // 4. 화면 정보
    components.push(`${screen.width}x${screen.height}`);
    components.push(String(screen.colorDepth));
    components.push(String(screen.pixelDepth));
    components.push(String(window.devicePixelRatio));

    // 5. 시간대
    components.push(Intl.DateTimeFormat().resolvedOptions().timeZone);

    // 6. 플러그인
    const plugins = Array.from(navigator.plugins || [])
        .map(p => p.name)
        .sort()
        .join(',');
    components.push(plugins);

    // SHA-256 해시 생성
    const data = components.join('|||');
    const encoder = new TextEncoder();
    const dataBuffer = encoder.encode(data);
    const hashBuffer = await crypto.subtle.digest('SHA-256', dataBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');

    return hashHex;
};
